import './RowOrder.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var dataTableV2DndHandleCSS = _7a468({defaultClassName:'_11esap21-2-0-1',variantClassNames:{disabled:{true:'_11esap22-2-0-1',false:'_11esap23-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var dataTableV2RowDndOverlayCSS = '_11esap20-2-0-1';
export var dataTableV2RowDraggingCSS = {transparent:'_11esap24-2-0-1',disabled:'_11esap25-2-0-1'};